import { useCallback, useRef } from 'react'

const useServiceWorkerUpdates = (onUpdateActive) => {
  const controllerChangeListenerAdded = useRef(false)

  const onControllerChange = useCallback(() => {
    if (controllerChangeListenerAdded.current) {
      onUpdateActive()
    }
    navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange)
  }, [onUpdateActive])

  const checkForServiceWorkerUpdates = useCallback(async () => {
    try {
      navigator.serviceWorker.addEventListener(
        'updatefound',
        (event) => {
          const registration = event.target
          const newWorker = registration.installing
          newWorker.addEventListener(
            'statechange',
            () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' })
                }
              }
            },
            { once: true }
          )
        },
        { once: true }
      )

      if (!controllerChangeListenerAdded.current) {
        navigator.serviceWorker.addEventListener('controllerchange', onControllerChange, { once: true })
        controllerChangeListenerAdded.current = true
      }

      const registration = await navigator.serviceWorker.ready

      await registration.update()

      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
    } catch (error) {
      console.error('Error checking for service worker updates:', error)
    }
  }, [onControllerChange])

  return checkForServiceWorkerUpdates
}

export default useServiceWorkerUpdates
